export const activityPageConstants = {
  SET_ACTIVITY_DATA: 'SET_ACTIVITY_DATA',
  SET_IS_FETCHING: 'SET_IS_FETCHING',

  // clear activity
  CLEAR_ACTIVITY: "CLEAR_ACTIVITY"
};
